function inputDate(id) {
  $(id).inputmask('99.99.9999',
   {
      placeholder: "дд.мм.гггг",
      showMaskOnHover: false,
      // oncomplete: function() {
      //   const dateArr = this.value.split('.');
      //   const date = new Date(`${dateArr[1]}.${dateArr[0]}.${dateArr[2]}`);
      //   $(this).data('datepicker').selectDate(date)
      // }
    })
}

